module.exports = __webpack_public_path__ + "img/08.7ef61449.png";